/**
 * Created by LiuYang on 2017/7/19.
 */

import config from 'config';
import {
    lazyload
} from '../common/Fn';
import {
    isFunction,
    get
} from 'lodash';
import User from 'src/service/User';
import defer from 'src/class/Defer';

export default class Mta {
    static loadingStatus = 'init';            // 加载状态: init, pending, resolve, reject

    static callbacks = [];

    /**
     * 加载页面埋点，并发送统计信息
     * @param url
     * @param cfg
     * @returns {*}
     */
    static load(url = config.mta.url, cfg = config.mta.config){
        let status = url ? Mta.loadingStatus : '';
        let ret;
        switch (status) {
            case 'init':
            case 'reject':
                Mta.loadingStatus = 'pending';
                ret = User.userIsLogin(true).then(function (uInfo) {
                    global['_mtac'] = {
                        'userReport': 1
                    };
                    global['_user'] = {
                        'user_id': uInfo.id
                    };
                    return cfg;
                }, function(){
                    return cfg;
                }).then(function (cfg) {
                    return lazyload(url, cfg).then(()=>{
                        Mta.loadingStatus = 'resolve';
                        let current = null;
                        while (current = Mta.callbacks.shift()){
                            current.resolve();
                        }
                    },()=>{
                        Mta.loadingStatus = 'reject';
                        let current = null;
                        while (current = Mta.callbacks.shift()){
                            current.reject();
                        }
                        return Promise.reject();
                    });
                });
                break;
            case 'pending':
                let deferInstance = defer();
                Mta.callbacks.push(deferInstance);
                ret = deferInstance.promise;
                break;
            case 'resolve':
                ret = Promise.resolve();
                break;
            default:
                ret = Promise.reject();
        }

        return ret;
    }

    // 复写的方法
    static __public = {
        /**
         * 发送页面pv请求
         */
        pgv(...arg){
            if(Mta.loadingStatus === 'resolve') {
                MtaH5.pgv(...arg);
            } else {
                Mta.load();
            }
        }
    };
  
    /**
     * 需要执行的命令
     * @param command
     * @param args
     */
    static command(command, ...args){
        if(['pgv'].indexOf(command) != -1) {
            Mta['__public'][command](...args);
        } else {
            let resolveFn = ()=>{
                if(isFunction(get(global, 'MtaH5.' + command))) {
                    MtaH5[command](...args);
                }
            };
            Mta.load().then(resolveFn, ()=>{
                let deferInstance = defer();
                deferInstance.promise.then(resolveFn, ()=>{

                });
                Mta.callbacks.push(deferInstance);
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/service/Mta.js